import { useContext } from 'react';
import { TenantConfigContext } from 'context/TenantConfigContext';
import { runtimeConfig } from 'config/runtimeConfig';
import { useTokenPermissions } from './useTokenPermissions';

export function useShouldSkipMatomoTracking(): boolean {
  const { accountNumber, isAdminView, testTenantFlag } = useContext(TenantConfigContext);
  const [tokenPermissions] = useTokenPermissions();
  const isStagingEnv = runtimeConfig.ENV_NAME === 'staging';
  const isSmokeAccount = accountNumber === '360smoke';
  const permissionsString = tokenPermissions.join(',');
  const isSuperAdmin = permissionsString.includes('tb360:super_admin');
  const isSupportAdmin = permissionsString.includes('read:all_accounts');

  return !isStagingEnv && (isAdminView || isSupportAdmin || isSuperAdmin || (testTenantFlag && !isSmokeAccount));
}
